import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {Device} from './device';
import {BaseApi, ListFilter, ListResult, Pagination} from '@shared/base';
import {ApiUtils} from '@shared/utils/api.utils';

@Injectable({
  providedIn: 'root'
})
export class DeviceApi extends BaseApi<Device> {
  protected readonly httpClient: HttpClient;

  constructor() {
    const httpClient = inject(HttpClient);

    super(httpClient, 'devices');
  
    this.httpClient = httpClient;
  }

  create(): Device {
    return new Device();
  }

  public findByFilter(listFilter: ListFilter, pagination: Pagination): Observable<ListResult<Device>> {
    const httpParams = ApiUtils.createHttpParams({...listFilter, ...pagination.toListFilter()});

    return this.httpClient.get<ListResult<Device>>(`${this.endpoint}/search`, {params: httpParams}).pipe(map(value => {
      value.data.forEach(device => {
        if (!device['@type']) {
          device['@type'] = 'DeviceDto';
        }
      });

      return Object.assign(new ListResult<Device>(), value);
    }));
  }
}
